/**
 * 编码规则 - 运行时
 *
 *   ttx.codeRule.generate(serviceCode, callback)  // 预览编码（不递增）
 *   ttx.codeRule.consume(serviceCode, callback)    // 确认占用（递增序号）
 *   ttx.codeRule.isEnabled(serviceCode, callback)  // 检查是否启用
 */
(function () {
    ttx.codeRule = {
        /**
         * 预览编码（不递增序号，新增页面预填用）
         */
        generate: function (serviceCode, callback) {
            ttx.ajax.xhrUtil({
                url: '/api/code-rule/generate',
                method: 'post',
                data: { serviceCode: serviceCode },
                success: function (res) {
                    callback(res?.data || res);
                },
                fail: function () {
                    callback(null);
                },
            });
        },

        /**
         * 确认占用编码（真正保存成功时调用，递增 currentSeq）
         */
        consume: function (serviceCode, callback) {
            ttx.ajax.xhrUtil({
                url: '/api/code-rule/consume',
                method: 'post',
                data: { serviceCode: serviceCode },
                success: function (res) {
                    callback(res?.data || res);
                },
                fail: function () {
                    callback(null);
                },
            });
        },

        /**
         * 检查 serviceCode 是否启用了编码规则
         */
        isEnabled: function (serviceCode, callback) {
            ttx.ajax.xhrUtil({
                url: '/api/code-rule/check?serviceCode=' + encodeURIComponent(serviceCode),
                method: 'get',
                success: function (res) {
                    callback(res?.data || res);
                },
                fail: function () {
                    callback({ enabled: false });
                },
            });
        },
    };
})();
